var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('p',{staticClass:"text-center text-gray h5"},[_vm._v(" No Alerts Found ")])])
}]

export { render, staticRenderFns }